module.exports = __webpack_public_path__ + "img/simply-money.731ee2cd.svg";